// extracted by mini-css-extract-plugin
module.exports = {"document":"CustomerGrin4UInfo_document__3Hzce","documentInput":"CustomerGrin4UInfo_documentInput__1hrAM","documentContent":"CustomerGrin4UInfo_documentContent__17vdI"};